"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rep_core_1 = require("@sa/rep-core");
const ReactReportingContextType_1 = require("./ReactReportingContextType");
// TODO: поправить
exports.ReactReportingContext = react_1.default.createContext(undefined);
exports.ReportingProvider = (props) => {
    const { children, reportDefinitionsService, serviceProvider, dataflowMiddlewares, componentContextsMiddlewares, componentsMiddlewares, } = props;
    // Создаём самый базовый контекст отчётности (сервис для управлвения )
    const reportingCoreContextOptions = {
        reportDefinitionsService,
        serviceProvider,
        componentContextsMiddlewares,
        dataflowMiddlewares,
    };
    const reportingContext = new rep_core_1.ReportingContext(reportingCoreContextOptions);
    const reactReportingContext = new ReactReportingContextType_1.ReactReportingContextType({
        reportingContext: reportingContext,
        componentsMiddlewares: componentsMiddlewares,
    });
    return react_1.default.createElement(exports.ReactReportingContext.Provider, { value: reactReportingContext }, children);
};
//# sourceMappingURL=ReportingProvider.js.map